import { Default } from './Default';
import { Multiple } from './Multiple';

type CompoundedComponent = typeof Default & {
	Multiple: typeof Multiple;
};

const Select = Default as CompoundedComponent;

Select.Multiple = Multiple;

export default Select;
